import { Component, OnInit, Input,Output ,EventEmitter} from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { ValidatorPasswordService } from "../../../components/password-validator/validator-password.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-set',
  templateUrl: './password-set.component.html',
  styleUrls: ['./password-set.component.sass']
})
export class PasswordSetComponent implements OnInit {
  @Input() viewSession;
  @Input() account;
  @Input() subscriber;
  @Input() txtType;

  @Input() ssn;
  @Input() email;
  @Input() securityCode;

  public validatePassword:boolean=true;
  public passwd:string='';
  public pswdOk:string = '';
  constructor(private loadingScreenService :LoadingScreenService ,private services: Service,private global:GlobalService,private validatorPasswordService:ValidatorPasswordService,private router:Router) { }

  ngOnInit() {}

  onKey(event: any){
    this.validatorPasswordService.onKey(event.target.value);
  }

  submitForm(){
      if (this.passwd === '' || this.pswdOk === '') {
          this.global.notif('Debe ingresar los datos solicitados.');
      }
      else if (this.passwd !== this.pswdOk ) {
        this.global.notif('Las contraseñas no coinciden.');
      }
      else if(!this.validatePassword){
          this.loadingScreenService.startLoading();
          this.services.registerUser(this.account,this.subscriber,this.ssn, this.email,this.passwd, this.securityCode).subscribe(data =>{
            this.loadingScreenService.stopLoading();
            if(data.hasError ==false){
              this.global.notif('Registro de usuario exitoso.');
                this.router.navigate(['/']);
            }
            else{
              this.global.notif(data.errorDisplay);
            }
          });
      }
      else{
        this.global.notif('Ingrese una contraseña válida.');
      }
  }
}